import { render, staticRenderFns } from "./CombatCard.vue?vue&type=template&id=0169f130&scoped=true&"
import script from "./CombatCard.vue?vue&type=script&lang=js&"
export * from "./CombatCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0169f130",
  null
  
)

export default component.exports